import { FileCheck2 } from 'lucide-react'
import { Button, Modal } from '@/components/ui'

export interface FinalizeLetterModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  customer: string
  pending: boolean
  error: string | null
  onConfirm: () => void
}

/** Finalizing is one-way, so it gets a confirmation that says exactly what happens. */
export function FinalizeLetterModal({
  open,
  onOpenChange,
  customer,
  pending,
  error,
  onConfirm,
}: FinalizeLetterModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      tone="warning"
      icon={FileCheck2}
      title={`Finalize the letter for ${customer}?`}
      description="This cannot be undone."
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={() => onOpenChange(false)} disabled={pending}>
            Cancel
          </Button>
          <Button variant="primary" size="sm" onClick={onConfirm} disabled={pending}>
            {pending ? 'Finalizing…' : 'Finalize letter'}
          </Button>
        </>
      }
    >
      <ul className="m-0 flex list-disc flex-col gap-1 pl-5 text-sm text-secondary">
        <li>The PDF is created and saved. The letter can no longer be edited.</li>
        <li>The PDF is attached to {customer} in Odoo.</li>
        <li>Nothing is emailed. You download the PDF and send it yourself.</li>
        <li>No prices are changed in Odoo.</li>
      </ul>
      {error ? <p className="mt-2 text-xs text-danger">{error}</p> : null}
    </Modal>
  )
}
